/**
 * Top-level aggregator. `getLiturgicalDay(date)` returns a single record
 * containing everything the API or UI needs for that date.
 *
 * Pure, deterministic, no I/O. Returns saint/feast slugs only, the API
 * hydrates them against the database for names, biographies, etc.
 */
import { paschaGregorian } from './pascha.js';
import { toneForDate } from './tones.js';
import { resolveFeasts, primaryFeast } from './feasts.js';
import { fastingForDateAllLevels } from './fasting.js';
import { readingsForDate } from './readings.js';
import { dayOfWeek, fixedDateFor, fromIso, toIso, } from './dates.js';
export function getLiturgicalDay(input, calendarStyle = 'new') {
    const date = normalize(input);
    const pascha = paschaGregorian(date.year);
    const feasts = resolveFeasts(date, pascha, calendarStyle);
    return {
        date,
        iso: toIso(date),
        dayOfWeek: dayOfWeek(date),
        pascha,
        fixedDate: fixedDateFor(date, calendarStyle),
        tone: toneForDate(date),
        primaryFeast: primaryFeast(date, pascha, calendarStyle),
        feasts,
        fasting: fastingForDateAllLevels(date, calendarStyle),
        // Readings stay on the civil date in v1: the movable daily lectionary is
        // identical in both calendars; shifting fixed-feast readings is a follow-up.
        readings: readingsForDate(date, pascha),
    };
}
function normalize(input) {
    if (typeof input === 'string')
        return fromIso(input);
    if (input instanceof Date) {
        return {
            year: input.getUTCFullYear(),
            month: input.getUTCMonth() + 1,
            day: input.getUTCDate(),
        };
    }
    return input;
}
// Re-exports for granular consumers.
export { paschaGregorian, paschaJulian } from './pascha.js';
export { toneForDate } from './tones.js';
export { resolveFeasts, primaryFeast, FIXED_FEASTS, MOVABLE_FEASTS } from './feasts.js';
export { fastingForDate, fastingForDateAllLevels, fastingPeriodForDate, fastingPeriodsForYear, } from './fasting.js';
export { readingsForDate } from './readings.js';
export { fromIso, toIso, addDays, diffDays, dayOfWeek, julianGregorianOffset, fixedDateFor, } from './dates.js';
//# sourceMappingURL=index.js.map